class Errors {
	/**
	 * Initialize the class
	 */
	constructor() {
		this.errors = {};
	}
	
	/**
	 * Determine if form has errors.
	 */
	any() {
		return Object.keys(this.errors).length > 0;
	}
	
	/**
	 * Get a field's error.
	 * 
	 * @param {string} field_name
	 */
	get(field_name) {
		if (!_.isNil(this.errors[field_name])) {
			return this.errors[field_name][0];
		}
	}
	
	/**
	 * Determine if a field has an error.
	 * 
	 * @param {string} field_name
	 */
	has(field_name) {
		return this.errors.hasOwnProperty(field_name);
	}
	
	/**
	 * Record errors.
	 * 
	 * @param {object} errors
	 */
	record(errors) {
		this.errors = errors;
	}
	
	/**
	 * Clear either a single field's errors, or the form's errors.
	 * 
	 * @param {string} field_name
	 */
	clear(field_name) {
		if (field_name) {
			delete this.errors[field_name];
			return;
		}
		
		this.errors = {};
	}
}

export default Errors;